/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Applyfilters1Inputs */

const en_btn_applyfilters1 = /** @type {(inputs: Btn_Applyfilters1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply Filters`)
};

/**
* | output |
* | --- |
* | "Apply Filters" |
*
* @param {Btn_Applyfilters1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_applyfilters1 = /** @type {((inputs?: Btn_Applyfilters1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Applyfilters1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_applyfilters1(inputs)
});
export { btn_applyfilters1 as "btn_applyFilters" }